export class AddressCountry
{
	id = "";
	code = "";
	alpha3Code = "";
	showPostalCode: boolean;
	stateProvinceLabel = "";
	name = "";
}


// WEBPACK FOOTER //
// ./src/models/AddressCountry.ts